import { BeatLoader } from "react-spinners";
import "./index.css";
const LoadingView = () => (
  <div className="loader-container">
    <BeatLoader color="#ff0f24" />
  </div>
);

export default LoadingView;
